module.exports = __webpack_public_path__ + "02_glasses_red.cfcebd78.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer4/02_glasses_red.png
// module id = Rf51
// module chunks = 0